import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled';
import ScrollToTop from 'lib/scroll/scroll-to-top';
import Helmet from 'helmet/helmet';
import Route from 'react-router/route';

import defaultStyles from './cms-view.scss';

export class CMSItemViewModel {
    cmsItem;

    constructor(cmsItem) {
        this.cmsItem = cmsItem;
    }

    toJSON() {
        return null;
    }
}

@Styled(defaultStyles)
class CMSItemView extends React.PureComponent {
    static contextTypes = {
        origin: PropTypes.string,
    };

    renderHelmet = H => {
        const { cmsItem } = this.props.cmsItemViewModel;

        let title = 'CMS';

        const h1 = cmsItem.content.split('</h1>')[0];

        if (/<h1>/.test(h1)) {
            title = h1.replace('<h1>', '');
        }

        return (
            <Route>
                {({ location }) => (
                    <H>
                        <title>{title}</title>,
                        <meta property='og:title' content={title} />,
                        <meta property='og:url' content={`${this.context.origin}${location.pathname}`} />,
                    </H>
                )}
            </Route>
        );
    };

    render() {
        const { cmsItem } = this.props.cmsItemViewModel;
        const { styles } = this.props;
        return (
            <React.Fragment>
                <ScrollToTop cmsItem={cmsItem} />
                <Helmet render={this.renderHelmet} />
                <div className={styles.cmsItem} dangerouslySetInnerHTML={{ __html: cmsItem.content }} />
            </React.Fragment>
        );
    }
}

export default CMSItemView;
